module.exports = __webpack_public_path__ + "brand-icons.a1a749e89f578a49306e.svg";


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/assets/semantic/themes/default/assets/fonts/brand-icons.svg
// module id = ../../../../../src/assets/semantic/themes/default/assets/fonts/brand-icons.svg
// module chunks = styles